var _excluded = ["align", "className", "currentPage", "maxButtons", "selectPage", "size", "totalPages"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled, { css } from 'styled-components';
import * as IconSet from "../../../icons/index.js";
import Button from "../../basic/Button/Button.js";
var PaginationAlignments = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var ButtonWidths = {
  small: '24px',
  medium: '36px',
  large: '54px'
};
var sharedStyles = align => css(["align-items:flex-start;display:flex;gap:var(--spacing-1);justify-content:", ";"], PaginationAlignments[align]);
var StyledPagination = styled.nav.withConfig({
  componentId: "CL__sc-18hws3e-0"
})(["", ";width:100%;"], _ref => {
  var {
    align
  } = _ref;
  return sharedStyles(align);
});
var StyledButtonWrapper = styled.div.withConfig({
  componentId: "CL__sc-18hws3e-1"
})(["", ";flex-wrap:wrap;"], _ref2 => {
  var {
    align
  } = _ref2;
  return sharedStyles(align);
});
var StyledPaginationButton = styled(Button).withConfig({
  componentId: "CL__sc-18hws3e-2"
})(["aspect-ratio:1;padding:0;height:", ";&.hidden{opacity:0;}"], _ref3 => {
  var {
    size
  } = _ref3;
  return ButtonWidths[size];
});
var Pagination = _ref4 => {
  var {
      align = 'center',
      className,
      currentPage,
      maxButtons = 9,
      selectPage,
      size = 'medium',
      totalPages
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  var createPaginationItem = index => {
    var isActive = currentPage === index + 1;
    return /*#__PURE__*/React.createElement(StyledPaginationButton, {
      "aria-label": "Navigate to page ".concat(index + 1),
      key: "pagination-item-".concat(index + 1),
      size: size,
      onClick: () => selectPage(index + 1),
      variant: isActive ? 'secondary' : 'text'
    }, index + 1);
  };
  var createPaginations = () => {
    var paginations = [];
    var halfwayPoint = Math.ceil(maxButtons / 2);
    var min = 0;
    if (currentPage > halfwayPoint) min = currentPage - halfwayPoint;
    [...Array(maxButtons)].forEach((_e, i) => {
      var pageNumber = i + min;
      if (pageNumber > totalPages - 1) return;
      paginations.push(createPaginationItem(pageNumber));
    });
    return paginations;
  };
  return /*#__PURE__*/React.createElement(StyledPagination, _extends({
    align: align,
    "aria-label": "Pagination",
    className: className
  }, props), /*#__PURE__*/React.createElement(StyledPaginationButton, {
    "aria-label": "Navigate to previous page",
    disabled: currentPage === 1,
    icon: IconSet.ArrowLeft,
    size: size,
    onClick: () => selectPage(currentPage - 1),
    variant: "text"
  }), /*#__PURE__*/React.createElement(StyledButtonWrapper, {
    align: align
  }, createPaginations()), /*#__PURE__*/React.createElement(StyledPaginationButton, {
    "aria-label": "Navigate to next page",
    disabled: currentPage === totalPages,
    icon: IconSet.ArrowRight,
    size: size,
    onClick: () => selectPage(currentPage + 1),
    variant: "text"
  }));
};
export default Pagination;